import { Time } from "./time";

import { Validateable, HasSocketEvent } from "@models/interfaces";
import { SocketEvent } from "@helpers/types";

export class PriceAlert extends Validateable implements HasSocketEvent {
	private fiat_id: string = "";
	private cryptocoin_id: string = "1";
	private amount: string = "";
	private time_created: Time = new Time();
	private comparison: string = "";
	private types: string[];

	public eventData: SocketEvent = "";

	public getEvent(): string {
		return this.eventData;
	}

	public setAmount(val: number): void {
		this.amount = val + "";
	}

	public getFiatId(): string {
		return this.fiat_id;
	}

	public setFiatId(fiatId: string): void {
		this.fiat_id = fiatId;
	}

	public setCurrencyId(id: string): void {
		this.cryptocoin_id = id;
	}

	public getTypes(): string[] {
		return this.types;
	}

	public setTypes(types: string[]): void {
		this.types = types;
	}

	public getAmount(): number {
		return +this.amount;
	}

	public get _amount(): string {
		return this.amount;
	}

	public set _amount(n: string) {
		this.amount = "" + n;
	}

	public getTime(): Time {
		return this.time_created;
	}

	public getCurrencyId(): string {
		return this.cryptocoin_id;
	}

	public getVerb(): string {
		return this.comparison === "GREATER" ? "price_is_above" : "price_is_below";
	}
}
